import {salvarArquivoResposta} from '../../../utils/download.js';

/*
 * Download de arquivo gerado pelo back (GET com responseType 'blob'): o nome do arquivo é
 * montado no front, sem depender do Content-Disposition.
 */

/* Salva o Blob recebido como arquivo `nomeArquivo` (cria o link, clica e libera a URL). */
export const salvarBlob = (blob, nomeArquivo) => salvarArquivoResposta({data: blob, headers: {}}, nomeArquivo);

/* Erro de um GET/POST com responseType 'blob': o corpo do erro também chega como Blob; devolve texto ou objeto. */
export const lerErroDeArquivo = erro => {
    if (erro && typeof erro.text === 'function') {
        return erro.text().then(texto => {
            try {
                return JSON.parse(texto);
            } catch (e) {
                return texto;
            }
        });
    }

    return Promise.resolve(erro);
};
